import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
//
//
//
//
//
//
export default {
  name: 'BaseLink',
  props: {
    link: {
      type: [Object, String],
      required: true
    },
    target: {
      type: String,
      default: '_blank'
    }
  },
  computed: {
    attributes: function attributes() {
      var url = ''; // this.resolveUrl(this.link)

      if (url.match(/^(http(s)?|ftp):\/\//)) {
        return {
          is: 'a',
          href: url,
          target: this.target,
          rel: 'noopener'
        };
      }

      return {
        is: 'a',
        to: '' // this.localePath(url),

      };
    }
  }
};